import { fetchJsonCached } from "./apiCache";

// Фоновый prefetch текущего расписания — запускается при старте приложения,
// чтобы данные попали в localStorage даже если пользователь не заходил на /schedule.
export function prefetchCurrentSchedule() {
  setTimeout(() => {
    const origin = window.location.origin;
    ["ALL", "ВО", "СПО"].forEach(source => {
      fetchJsonCached(
        `${origin}/schedule/week?source=${encodeURIComponent(source)}`,
        { cacheKey: `schedule:week:${source}:current`, ttlMs: 2 * 60_000 }
      ).catch(() => {});

      fetchJsonCached(
        `${origin}/export/weeks?source=${encodeURIComponent(source)}`,
        { cacheKey: `export:weeks:${source}`, ttlMs: 5 * 60_000 }
      ).catch(() => {});
    });
  }, 3000);
}
